function preloadFonts(fonts) {
    return Promise.all(fonts.map(font => {
        const fontFace = new FontFace(font.name, `url(${font.url})`);
        return fontFace.load().then(() => {
            document.fonts.add(fontFace);
        });
    }));
}

if (!customElements.get('personaliser-modal')) {
    customElements.define(
        'personaliser-modal',
        class PersonaliserModal extends ModalDialog {
            constructor() {
                super();
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                // MutationObserver to detect when the modal is opened
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.attributeName === 'open') {
                            if (this.hasAttribute('open')) {
                                this.updateVariantPrice();
                                if (window.personaliserFonts) {
                                    preloadFonts(window.personaliserFonts).then(() => {
                                        this.applyInitialFonts();
                                    }).catch(error => {
                                        console.error('Failed to preload fonts:', error);
                                    });
                                }
                            }
                        }
                    });
                });

                observer.observe(this, { attributes: true });

        

                this.querySelectorAll('[data-role="user-input"]')
                    .forEach(input => {
                        this.updateVariantPrice(); // Call on initialization

                        // Add maxlength enforcement
                        input.addEventListener('input', (event) => {
                            if (event.target.value.length > event.target.maxLength) {
                                event.target.value = event.target.value.slice(0, event.target.maxLength);
                            }
                            this.updateCharCount(event.target);
                        });

                        ['keyup', 'input'].forEach(type => input.addEventListener(type, (event) => {
                            this.applyFontLogic(event.target);
                            this.updateCharCount(event.target);
                            this.updateSubtotal(); // Recalculate subtotal on input changes
                        }));
                        // Initialize character count
                        this.updateCharCount(input);
                    });
                   

                // Event listener for variant selection
                const variantSelectors = document.querySelectorAll('input[type="radio"]');
                const personaliserAddButton = this.querySelector('[data-role="personaliser-add"]');
                
                variantSelectors.forEach(selector => {
                    selector.addEventListener('change', function() {
                        this.updateVariantPrice(); // Call the method to update the variant price and subtotal
                    }.bind(this));
                });

                // Ensure to call `updateSubtotal()` initially to set the correct subtotal
                this.updateSubtotal();
                
                this.querySelector('[data-role=personaliser-add]').addEventListener('click', this.handleSubmitClick.bind(this));

                const inputs = this.querySelectorAll('[data-role="user-input"]');
                const personalisePrice = parseFloat(document.querySelector('.product-popup-modal__content-info').getAttribute('data-personalise-price'));
                const subtotalContainer = document.querySelector('[data-role="subtotal"]');
                const subtotal = parseFloat(subtotalContainer.getAttribute('data-subtotal'));
                const priceContainer = document.querySelector('[data-role="engraving-total"]');

                const recalculatePrice = () => {
                    let calculatedPrice = 0.0;
                    inputs.forEach(input => {
                        if (input.value.length > 0) {
                            calculatedPrice += personalisePrice;
                        }
                    });
                    return calculatedPrice * 100;
                };
inputs.forEach(input => {
                    input.addEventListener('keyup', function () {
                        const calculatedPrice = recalculatePrice();
                        priceContainer.innerHTML = Shopify.formatMoney(calculatedPrice);
                        priceContainer.setAttribute('data-raw-price', (calculatedPrice / 100).toFixed(2));
                        this.updateSubtotal();
                    }.bind(this));
                });
            }
            
            
            updateVariantPrice() {
    const selectedVariant = document.querySelector('input[type="radio"][name]:checked');
    if (selectedVariant) {
        const variantPrice = parseFloat(selectedVariant.getAttribute('data-price')) || 0;
        
        // Ensure 'this' is correctly scoped to the class instance
        const personaliserAddButton = this.querySelector('[data-role="personaliser-add"]');
        if (personaliserAddButton) {
            personaliserAddButton.setAttribute('data-price', variantPrice.toFixed(2));
            this.updateSubtotal(); // Recalculate subtotal with the new variant price
        } else {
            console.error('Personaliser add button not found');
        }
    }
}

            updateCharCount(input) {
                const maxLength = input.dataset.font === 'round-monogram' || input.dataset.font === 'interlocking' ? 3 : input.maxLength;
                var charCountElement = input.nextElementSibling;
            
                if (!charCountElement || !charCountElement.classList.contains('char-count')) {
                    charCountElement = document.createElement('div');
                    charCountElement.className = 'char-count';
                    input.parentNode.insertBefore(charCountElement, input.nextSibling);
                }
            
                charCountElement.textContent = `${input.value.length}/${maxLength}`;
            }

            

updateSubtotal() {
                const personaliserAddButton = document.querySelector('[data-role="personaliser-add"]');
                const variantPrice = parseFloat(personaliserAddButton.getAttribute('data-price')) || 0;
            
                const engravingTotalEl = document.querySelector('[data-role="engraving-total"]');
                const engravingPrice = parseFloat(engravingTotalEl.getAttribute('data-raw-price')) || 0;
            
                const totalPrice = variantPrice + engravingPrice;
            
                const subtotalContainer = document.querySelector('[data-role="subtotal"]');
                if (subtotalContainer) {
                    subtotalContainer.innerHTML = Shopify.formatMoney(totalPrice * 100);
                    subtotalContainer.setAttribute('data-subtotal', totalPrice.toFixed(2));
                } else {
                    console.error('Subtotal element missing');
                }
            }
            updateFontSelectorStyle(selector, fontValue) {
                if (fontValue === 'round-monogram' || fontValue === 'interlocking') {
                    selector.style.fontFamily = 'serif';
                } else {
                    selector.style.fontFamily = fontValue;
                }
            }

            applyInitialFonts() {
                // Apply the initial fonts here if needed
                this.querySelectorAll('[data-role="font-selector"]')
    .forEach(selector => selector.addEventListener('change', function(event) {
        this.updateFontSelectorStyle(selector, event.target.value);
        const userInput = this.querySelector('[data-side=' + selector.dataset.side + '][data-role="user-input"]');
        if (userInput) {
            userInput.dataset.font = event.target.value;
            this.applyFontLogic(userInput);
        }
        this.displayFontMessage(selector, event.target.value);
        // Update the character count
        this.updateCharCount(userInput);
    }.bind(this)));
            }

            displayFontMessage(selector, fontValue) {
    let messageElement = selector.parentElement.parentElement.querySelector('.font-message');
    if (!messageElement) {
        messageElement = document.createElement('div');
        messageElement.className = 'font-message';
        selector.parentElement.parentElement.appendChild(messageElement);
    }

    if (fontValue === 'round-monogram' || fontValue === 'interlocking') {
        messageElement.textContent = translateFontLimitMessage;
        messageElement.style.display = 'block';
    } else {
        messageElement.style.display = 'none';
    }
}

applyFontLogic(input) {
    const selectedFont = input.dataset.font;
    let text = input.value;
    const sidePreview = this.querySelector('[data-role=' + input.dataset.side + '-preview]');
    const maxLines = 10;

    // Store the original text if switching to a special font and it's not already stored
    if ((selectedFont === 'round-monogram' || selectedFont === 'interlocking') && !input.dataset.originalText) {
        input.dataset.originalText = text;
        
    }

    // Add maxlength enforcement
    if (text.length > input.maxLength) {
        text = text.slice(0, input.maxLength);
        input.value = text;
    }

    // Truncate text to a maximum of 2 lines for other fonts
    if (selectedFont !== 'interlocking' && selectedFont !== 'round-monogram') {
        const lines = text.split('\n').slice(0, maxLines);
        text = lines.join('\n');
        input.value = text;
    }

    if (selectedFont === 'round-monogram') {

        // Truncate text to 3 characters if it's longer or contains spaces/newlines
        if (text.length > 3 || /\s/.test(text)) {
            text = text.replace(/\s/g, '').slice(0, 3);
            input.value = text;
        }

        let newText = '';
        if (text.length === 0) {
            const exampleText = 'Example'.substring(0, 3);
            if (exampleText.length > 0) {
                newText += `<span style="font-family: round-monogram-l; font-size:7rem;">${exampleText.charAt(0)}</span>`;
            }
            if (exampleText.length > 1) {
                newText += `<span style="font-family: round-monogram-c; font-size:7rem;">${exampleText.charAt(1)}</span>`;
            }
            if (exampleText.length > 2) {
                newText += `<span style="font-family: round-monogram-r; font-size:7rem;">${exampleText.charAt(2)}</span>`;
            }
        } else {
            if (text.length > 0) {
                newText += `<span style="font-family: round-monogram-l; font-size:7rem;">${text.charAt(0)}</span>`;
            }
            if (text.length === 2) {
                newText += `<span style="font-family: round-monogram-r; font-size:7rem;">${text.charAt(1)}</span>`;
            }
            if (text.length === 3) {
                newText += `<span style="font-family: round-monogram-c; font-size:7rem;">${text.charAt(1)}</span>`;
                newText += `<span style="font-family: round-monogram-r; font-size:7rem;">${text.charAt(2)}</span>`;
            }
        }
        sidePreview.innerHTML = newText;
    } else if (selectedFont === 'interlocking') {

        // Truncate text to 3 characters and remove new lines/spaces
        if (text.length > 3 || /\s/.test(text)) {
            text = text.replace(/\s/g, '').slice(0, 3);
            input.value = text;
        }

        let newText = '';
        if (text.length === 0) {
            newText = 'eXa';
        } else if (text.length === 1) {
            newText = text.toUpperCase();
        } else if (text.length === 2) {
            newText = text.toUpperCase();
        } else if (text.length === 3) {
            newText = text.charAt(0).toLowerCase() + text.charAt(1).toUpperCase() + text.charAt(2).toLowerCase();
        }
        sidePreview.innerHTML = `<span style="font-family: interlocking; font-size:7rem;">${newText}</span>`;
    } else {

        // Restore the original text if switching back to a normal font
        if (input.dataset.originalText) {
            text = input.dataset.originalText;
            input.value = text;
            delete input.dataset.originalText;
        }

        sidePreview.innerHTML = text.length === 0 
            ? `<span style="font-family: ${selectedFont}">Example</span>` 
            : `<span style="font-family: ${selectedFont}">${text.replace(/\n/g, '<br>')}</span>`;
    }
}

handleSubmitClick(e) {
    let hasValidSide = false;
    let incompleteSides = [];

    Array.from(e.currentTarget.parentElement.querySelectorAll('.personaliser-sides > div')).forEach(side => {
        const dropdownInput = side.querySelector('[data-role="font-selector"]');
        const textInput = side.querySelector('[data-role="user-input"]');
        let sideLabel = dropdownInput ? dropdownInput.getAttribute('data-side') : 'a side';

        if (textInput && textInput.value.trim() !== '') {
            if (!dropdownInput || dropdownInput.value.trim() === '') {
                // Transform sideLabel to a human-readable format
                sideLabel = sideLabel
                    .replace('_ENGRAVE_FONT', '')  // Remove suffix
                    .replace(/_/g, ' ')            // Replace underscores with spaces
                    .replace(/Engrave/gi, '')      // Remove the word "Engrave"
                    .trim()                        // Remove leading/trailing spaces
                    .toLowerCase()                 // Convert to lowercase
                    .replace(/(^|\s)\S/g, l => l.toUpperCase());  // Capitalize each word
                incompleteSides.push(sideLabel);
            } else {
                hasValidSide = true;
            }
        }
    });

    if (incompleteSides.length > 0) {
        e.preventDefault();
        if (incompleteSides.length === 1) {
            alert(translateChooseFontForSide.replace("{side}", incompleteSides[0]));
                } else {
            alert(translateChooseFontForAllSides);
        }
    } else if (!hasValidSide) {
        e.preventDefault();
        alert(translateChooseFontAndText);
    } else {
        this.hide();
    }
}
}
);
}